import { PhoneCountryCodeType } from '@bus/models';
import { CorrespondenceMethodEnum, NoYesEnum } from '../../../types/forms';
import { TradingDetailsServicePlanFormModelNew } from './formModel';

export const tradingDetailsInitialValues: TradingDetailsServicePlanFormModelNew = {
  tradingAs: '',
  legalName: '',
  vatLiable: NoYesEnum.yes,
  vatNumber: '',
  correspondenceMethod: CorrespondenceMethodEnum.email,
  countryCode: PhoneCountryCodeType.Ireland,
};
